import { Theme } from "@mui/material";
import { colors } from "../../../../ui/colors";

export const getCalendarStylesMonth = (theme: Theme, viewType: string) => {
  const isMonthView = viewType === "dayGridMonth";
  const isDayView = viewType === "timeGridDay";
  const isListView = viewType.toLowerCase().includes("list");

  const baseStyles = {
    "& .fc": {
      border: "none !important",
      fontFamily: "'Inter', sans-serif",
      "--fc-border-color": "#f0f0f0",
      "--fc-today-bg-color": "transparent",
      bgcolor: "transparent",
      px: 2,
    },
    "& .fc-view-harness": {
      bgcolor: "var(--fx-surface-base, #FFFFFF) !important",
      borderRadius: "20px",
      border: "1px solid var(--fx-surface-border, #E2E8F0)",
      overflow: "hidden",
      boxShadow: "0 4px 20px rgba(0,0,0,0.02)",
    },
    "& .fc-scrollgrid": {
      border: "none !important",
    },

    "& .fc-timegrid-event-harness": {
      margin: "2px !important",
    },
  };

  if (isListView) {
    return {
      ...baseStyles,
      "& .fc-list": {
        border: "none !important",
        backgroundColor: "var(--fx-surface-base, #FFFFFF) !important",
      },

      "& .fc-list-day-cushion": {
        backgroundColor: "var(--fx-surface-base, #FFFFFF) !important",
      },
      "& .fc-list-day": {
        backgroundColor: "var(--fx-surface-base, #FFFFFF) !important",
      },

      "& .fc-list-table": {
        backgroundColor: "var(--fx-surface-base, #FFFFFF) !important",
      },

      "& .fc-list-empty": {
        backgroundColor: "var(--fx-surface-base, #FFFFFF) !important",
        color: colors.gray[400],
        fontWeight: 600,
        textAlign: "center",
        padding: "50px !important",
      },

      "& .fc-list-event td": {
        borderColor: "var(--fx-surface-border, #E2E8F0) !important",
      },

      "& .fc-list-event:hover td": {
        backgroundColor: `${colors.orange.base}05 !important`,
      },
    };
  }

  // VISTA DE DÍA
  if (isDayView) {
    return {
      ...baseStyles,

      "& .fc-timegrid-slot-label-cushion": {
        fontSize: "0.7rem",
        fontWeight: 700,
        color: colors.gray[400],
        px: 2,
        textTransform: "uppercase",
      },
      "& .fc-timegrid-slot": {
        height: "50px !important",
        borderColor: "var(--fx-surface-border, #E2E8F0) !important",
      },

      "& .fc-col-header-cell": {
        bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
        py: 1,
      },
      "& .fc-col-header-cell-cushion": {
        fontSize: "0.85rem",
        fontWeight: 800,
        color: colors.orange.base,
        textDecoration: "none !important",
      },

      "& .fc-timegrid-now-indicator-line": {
        borderColor: colors.orange.base,
        borderWidth: "2px",
      },
      "& .fc-timegrid-now-indicator-arrow": {
        borderTopColor: colors.orange.base,
        borderBottomColor: colors.orange.base,
      },
    };
  }

  // VISTA DE MES
  if (isMonthView) {
    return {
      ...baseStyles,
      "& .fc-col-header-cell-cushion": {
        fontSize: "0.65rem",
        fontWeight: 800,
        color: "var(--fx-surface-texttertiary, #94A3B8)",
        textTransform: "uppercase",
        letterSpacing: "1px",
        textDecoration: "none !important",
      },

      "& .fc-daygrid-day": {
        border: "1px solid var(--fx-surface-border, #E2E8F0) !important",
      },
      "& .fc-daygrid-day-top": {
        display: "flex",
        padding: "4px 8px !important",
        justifyContent: "flex-start",
      },
      "& .fc-day-today": {
        bgcolor: "transparent !important",
        "& .fc-daygrid-day-number": {
          bgcolor: colors.orange.base,
          color: "white !important",
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "4px !important",
        },
      },
      "& .fc-day-sat, & .fc-day-sun": {
        "& .fc-col-header-cell-cushion, & .fc-daygrid-day-number": {
          color: `${colors.orange.base} !important`,
        },
      },
    };
  }

  return baseStyles;
};
